import { formatLabel } from "../../utils/catalogDisplay";
import {
  getCompactOverviewAccessLabel,
  isSimpleAccessEntry
} from "./detailUtils";
import CatalogDetailCompactChips from "./CatalogDetailCompactChips";

export default function CatalogEntryOverviewPanel({
  entry
}) {
  const purposes = entry?.purposeDomains || [];
  const simpleAccessSummary = isSimpleAccessEntry(entry)
    ? getCompactOverviewAccessLabel(entry)
    : null;

  const hasContent = Boolean(
    purposes.length ||
      simpleAccessSummary
  );

  if (!hasContent) {
    return null;
  }

  return (
    <section className="catalog-detail__panel catalog-detail__panel--overview catalog-detail__panel--metadata-rows">
      <h2>Overview</h2>

      <dl>
        {purposes.length > 0 && (
          <div>
            <dt>Purposes</dt>
            <dd>
              <CatalogDetailCompactChips
                values={purposes.map((value) => formatLabel(value))}
              />
            </dd>
          </div>
        )}

        {simpleAccessSummary && (
          <div>
            <dt>Access</dt>
            <dd>
              {["Free", "No account required"].includes(
                simpleAccessSummary
              ) ? (
                <CatalogDetailCompactChips
                  values={[simpleAccessSummary]}
                />
              ) : (
                simpleAccessSummary
              )}
            </dd>
          </div>
        )}
      </dl>
    </section>
  );
}
